import React from 'react';
import Navigation from '../components/layout/Navigation';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/sections/HeroSection';
import HomeAboutSection from '../components/sections/HomeAboutSection';
import ProductsSection from '../components/sections/ProductsSection';
import IndustriesSection from '../components/sections/IndustriesSection';
import WhyChooseUs from '../components/sections/WhyChooseUs';
import ManufacturingProcessSection from '../components/sections/ManufacturingProcessSection';
import SustainabilityCommitmentSection from '../components/sections/SustainabilityCommitmentSection';
import ModernSection from '../components/sections/ModernSection';
import FloatingActions from '../components/layout/FloatingActions';

const Home = () => {
  return (
    <div className="min-h-screen site-root">
      <Navigation />
      <HeroSection />
      <HomeAboutSection />
      <ProductsSection />
      <IndustriesSection />
      <WhyChooseUs />
      <ManufacturingProcessSection />
      <SustainabilityCommitmentSection />
      <ModernSection />
      <Footer />
      <FloatingActions />
    </div>
  );
};

export default Home;
